import { FC, ReactNode } from 'react'
import BaseNotification, { NotificationIcon } from './BaseNotification'
import checkIcon from '../../images/icons/check.svg'

interface BaseSuccessProps {
  onClose: () => void
  header: string
  message: ReactNode
}

const successIcon: NotificationIcon = {
  src: checkIcon,
  alt: 'Success',
  containerStyle: {
    position: 'absolute',
    left: '10px',
    top: '10px',
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    border: '2px solid #228B22',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  imageStyle: {
    width: '16px',
    height: '16px',
    color: '#228B22',
  },
}

const BaseSuccess: FC<BaseSuccessProps> = ({ onClose, header, message }) => {
  return (
    <BaseNotification
      onClose={onClose}
      header={header}
      message={message}
      icon={successIcon}
      containerStyle={{ backgroundColor: '#E8FFE8' }}
      isHeaderInlineCloseButton={true}
    />
  )
}

export default BaseSuccess
